<template>
  <div class="clear-token-page">
    <h2>清除登录信息</h2>
    <p>正在清除浏览器中的登录信息...</p>
  </div>
</template>

<script>
export default {
  name: "ClearToken",
  mounted() {
    this.clearToken();
  },
  methods: {
    clearToken() {
      // 清除localStorage中的登录信息
      localStorage.removeItem("jyx_token");
      localStorage.removeItem("userName");
      localStorage.removeItem("userInfo");

      // 清除sessionStorage中的登录信息
      sessionStorage.removeItem("jyx_token");
      sessionStorage.removeItem("userName");
    },
  },
};
</script>

<style scoped>
.clear-token-page {
  text-align: center;
  padding: 50px;
}
</style>
